// src/components/Sidebar.jsx
import { NavLink } from "react-router-dom";
import SeriesMenu from "./SeriesMenu.jsx";
import { SERIES_STATE } from "../lib/seriesConfig.js";
import { useAuth } from "../auth/AuthProvider.jsx";

export default function Sidebar() {
    const closeSidebar = () => document.body.classList.remove("sidebar-open");
    const { user, loading } = useAuth();

    return (
        <aside className="sidebar">
            {/* Brand / Logo (über gesamte Breite, gelber Hover) */}
            <NavLink
                to="/"
                className="brand brand--full brand--hover"
                onClick={closeSidebar}
                aria-label="Zur Startseite"
            >
                <img src="/landing/Racevision-Logo.svg" alt="RaceVision" />
            </NavLink>

            {/* Navigation */}
            <nav className="nav">
                <NavLink
                    to="/manager"
                    end
                    className="nav-a nav-a--primary"
                    onClick={closeSidebar}
                >
                    <span>Liga Manager</span>
                </NavLink>

                {!loading && user?.role === "admin" && (
                    <div className="nav-admin">
                        <div className="nav-admin-title">Admin</div>

                        <NavLink
                            to="/manager/admin"
                            className="nav-a nav-a--sub"
                            onClick={closeSidebar}
                        >
                            <span>Dashboard</span>
                        </NavLink>

                        <NavLink
                            to="/manager/admin/import"
                            className="nav-a nav-a--sub"
                            onClick={closeSidebar}
                        >
                            <span>Standings Import</span>
                        </NavLink>

                        <NavLink
                            to="/manager/admin/polls"
                            className="nav-a nav-a--sub"
                            onClick={closeSidebar}
                        >
                            <span>Votings</span>
                        </NavLink>

                        <NavLink
                            to="/manager/admin/name-import"
                            className="nav-a nav-a--sub"
                            onClick={closeSidebar}
                        >
                            <span>Name Import</span>
                        </NavLink>

                        <NavLink
                            to="/manager/admin/users"
                            className="nav-a nav-a--sub"
                            onClick={closeSidebar}
                        >
                            <span>User</span>
                        </NavLink>
                    </div>
                )}

                {/* GT3 Xperience */}
                <SeriesMenu
                    title="GT3 Xperience"
                    titleImg="/landing/GT3X-Liga-Logo.png"
                    titleImgAlt="GT3 Xperience"
                    inactive={!SERIES_STATE.gt3x.active}
                    defaultOpen={true}
                    items={[
                        { to: "/gt3x/overview", label: "Overview" },
                        { to: "/gt3x/schedule", label: "Schedule" },
                        {
                            label: "Anmeldung",
                            isGroup: true,
                            children: [
                                { to: "/gt3x/anmeldung/anmelden", label: "Anmelden" },
                                { to: "/gt3x/anmeldung/anmeldeliste", label: "Anmeldeliste" },
                            ],
                        },
                        { to: "/gt3x/fahrer", label: "Fahrer" },
                        { to: "/gt3x/streamer", label: "Streamer" },
                        { to: "/gt3x/rules", label: "Regelwerk" },
                        {
                            label: "Raceday",
                            isGroup: true,
                            children: [
                                { to: "/gt3x/briefing", label: "Briefing" },
                                { to: "/gt3x/startfreigabe", label: "Startfreigabe" },
                            ],
                        },
                        {
                            label: "Standings",
                            isGroup: true,
                            children: [
                                { to: "/gt3x/standings/pro",    label: <span className="pill pill--pro">PRO</span> },
                                { to: "/gt3x/standings/int",    label: <span className="pill pill--int">INT</span> },
                                { to: "/gt3x/standings/am",     label: <span className="pill pill--am">AM</span> },
                                { to: "/gt3x/standings/team",   label: <span className="pill pill--team">TEAM</span> },
                                { to: "/gt3x/standings/marken", label: <span className="pill pill--marke">MARKE</span> },
                            ],
                        },
                        { to: "/gt3x/ergebnisse", label: "Ergebnisse" },
                        {
                            label: "Vorfälle",
                            isGroup: true,
                            children: [
                                // Reports.jsx
                                { to: "/gt3x/reports", label: "Incidents" },
                                // neue Protest-Seite (Formular)
                                { to: "/gt3x/protest", label: "Protest" },
                                // Penalties.jsx
                                { to: "/gt3x/penalties", label: "Fahrerlizenz" },
                            ],
                        },
                        {
                            label: "Archiv",
                            isGroup: true,
                            children: [
                                { to: "/gt3x/archiv/season1", label: "Season 1" },
                            ],
                        },

                    ]}
                    onNavigate={closeSidebar}
                />

                {/* Weitere Serie */}
                <SeriesMenu
                    title="GT Endu Xperience"
                    titleImg="/landing/EnduX-Liga-Logo.png"    // ← dein Endurance Bild
                    titleImgAlt="GT Endu Xperience"
                    inactive={!SERIES_STATE.gtex.active}
                    items={[{ to: "/gtex", label: "Noch nicht vorhanden" }]}
                    onNavigate={closeSidebar}
                />

                <SeriesMenu
                    title="GT4 Xperience"
                    titleImg="/landing/GT4X-Liga-Logo.png"    // ← dein Endurance Bild
                    titleImgAlt="GT4 Xperience"
                    inactive={!SERIES_STATE.gt4x.active}
                    items={[{ to: "/gt4x", label: "Noch nicht vorhanden" }]}
                    onNavigate={closeSidebar}
                />

                <SeriesMenu
                    title="Special Xperience"
                    titleImg="/landing/SpecialX-Liga-Logo.png"   // ← dein Endurance Bild
                    inactive={!SERIES_STATE.specialx.active}
                    titleImgAlt="Special Xperience"
                    items={[{ to: "/specialx", label: "Noch nicht vorhanden" }]}
                    onNavigate={closeSidebar}
                />
            </nav>

            {/* ➜ Instagram Link (neu) */}
            <div className="sidebar-social">
                <a
                    href="https://www.instagram.com/racevision.gg/"
                    target="_blank"
                    rel="noreferrer"
                    className="sidebar-social-link"
                >
                    <img
                        src="/icons/instagram.svg"
                        alt="Instagram"
                        className="sidebar-social-icon"
                    />
                    <span>@racevision.gg</span>
                </a>
                <a
                    href="https://discord.gg/2AteU7suuX"
                    target="_blank"
                    rel="noreferrer"
                    className="sidebar-social-link"
                >
                    <img
                        src="/icons/Discord.png"
                        alt="Discord"
                        className="sidebar-social-icon"
                    />
                    <span>RaceVision</span>
                </a>
                <a
                    href="https://www.youtube.com/@RacevisionTV"
                    target="_blank"
                    rel="noreferrer"
                    className="sidebar-social-link"
                >
                    <img
                        src="/icons/Youtube.png"
                        alt="Youtube"
                        className="sidebar-social-icon"
                    />
                    <span>@RacevisionTV</span>
                </a>
            </div>

            {/* Donate / Buy me a coffee */}
            <div className="sidebar-donate">
                <a
                    href="https://buymeacoffee.com/racevision"
                    target="_blank"
                    rel="noreferrer"
                    className="sidebar-donate-link"
                >
                    <img
                        src="/assets/buy-coffee.png"
                        alt="Buy Me a Coffee"
                        className="sidebar-donate-icon"
                    />
                    <span>Buy us some fuel</span>
                </a>
            </div>

            {/* ➜ Footer-Logo unten */}
            <div className="sidebar-footer">
                <a
                    href="https://www.bavariansimtec.com"   // <-- deine Wunsch-URL
                    target="_blank"
                    rel="noreferrer"
                    className="sidebar-footer-link"
                >
                    <img
                        src="/landing/Sidebar-Sponsor.svg"
                        alt="Powered by Bavarian SimTec"
                        className="sidebar-footer-logo"
                    />
                </a>
            </div>
        </aside>
    );
}
